export default __webpack_public_path__ + "static/media/Note1.d4930fc2.svg";